export const platformHost = (tenant, platform, baseDomain = process.env.REACT_APP_PLATFORM_BASE_DOMAIN || "delibran.app") => `${tenant}.${platform}.${baseDomain}`;
